'use client';

import { OnboardingFormSchema, PROGRAM_STATUS_ENUMS } from '../components/Onboarding/types';
import { CCMS_PROGRAM_TYPE_ENUMS } from '../constants/programs';
import { stripTrailingSlash } from '../utils/utils';
import { FetchBase, MARKETPLACE_PROGRAM_TYPES, MarketplaceSchoolBodyType, MarketplaceUserBodyType } from './types';

export const convertProgramTypes = (ccmsType: CCMS_PROGRAM_TYPE_ENUMS): MARKETPLACE_PROGRAM_TYPES => {
  const hash = {
    [CCMS_PROGRAM_TYPE_ENUMS.childCareCenter]: MARKETPLACE_PROGRAM_TYPES.center,
    [CCMS_PROGRAM_TYPE_ENUMS.exempt]: MARKETPLACE_PROGRAM_TYPES.exempt,
    [CCMS_PROGRAM_TYPE_ENUMS.familyChildCare]: MARKETPLACE_PROGRAM_TYPES.fcc,
    [CCMS_PROGRAM_TYPE_ENUMS.forestSchool]: MARKETPLACE_PROGRAM_TYPES.forest,
    [CCMS_PROGRAM_TYPE_ENUMS.microSchool]: MARKETPLACE_PROGRAM_TYPES.micro,
    [CCMS_PROGRAM_TYPE_ENUMS.ministry]: MARKETPLACE_PROGRAM_TYPES.ministry,
    [CCMS_PROGRAM_TYPE_ENUMS.other]: MARKETPLACE_PROGRAM_TYPES.other,
  };

  return hash[ccmsType];
};

const MARKETPLACE_BASE_URL = process.env.NEXT_PUBLIC_WS_MARKETPLACE_URL ?? 'https://www.wonderschool.com';
const WS_AUTH_FUNCTIONS_DOMAIN =
  process.env.NEXT_PUBLIC_WS_AUTH_FUNCTIONS_DOMAIN ?? 'https://us-central1-moxit-wonderschool-dev.cloudfunctions.net';

export async function wsAuthFetchBase({ endpoint, payload }: FetchBase) {
  const headers = new Headers({
    'Cache-Control': 'no-cache',
    mode: 'cors',
    'Content-Type': 'application/json',
  });

  return fetch(`${stripTrailingSlash(WS_AUTH_FUNCTIONS_DOMAIN)}/${endpoint}`, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });
}

export async function marketplaceFetchBase({ token, endpoint, payload }: FetchBase) {
  const headers = new Headers({
    'Cache-Control': 'no-cache',
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  });

  return fetch(`${stripTrailingSlash(MARKETPLACE_BASE_URL)}/${endpoint}`, {
    method: 'POST',
    credentials: 'include',
    headers,
    body: JSON.stringify(payload),
  });
}

export const transformSchoolPayload = (data: OnboardingFormSchema): MarketplaceSchoolBodyType => {
  return {
    address1: data.address1,
    address2: data.address2 || null,
    city: data.city,
    email: data.email,
    latitude: null,
    licenseCapacity: data.licenseCapacity,
    longitude: null,
    name: data.name,
    phone: data.phone || '',
    networkCode: data.networkCode || null,
    programStatus: data.programStatus ?? PROGRAM_STATUS_ENUMS.NEW,
    programType: convertProgramTypes(data.programType),
    state: data.state,
    zipcode: data.zipcode,
    newSupply: data.newSupply,
    timezone: data.timezone,
    ...(data.licenseNumber ? { licenseNumber: data.licenseNumber } : {}),
  };
};

export const transformUserPayload = (data: OnboardingFormSchema): MarketplaceUserBodyType => {
  return {
    email: data.email,
    first_name: data.firstName,
    last_name: data.lastName,
  };
};
